module.exports = __webpack_public_path__ + "static/media/Northville-Commons-Summary.12618a1c.pdf";